'use strict';

module.exports = {
  N: 'N',
  X: 'X',
  K: 'K',
  M: 'M',
  T: 'T',
};
